import styled from 'styled-components';
import Pallete from '../../theme';

const Container = styled.div`
    width: 100%;
`;

const InnerContainer = styled.div`
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
`;

export { Container, InnerContainer };
